import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { StoreSearchType } from "../../../ducks/store";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { PickUpDateSelect } from "../../molecules/store/PickUpDateSelect";
import { StoreList } from "../../organisms/store/StoreList";
import { useShopSearch } from "./hook";

type Props = {
  showAppCouponHeader: boolean;
};

export const ShopSearch: React.FC<Props> = ({ showAppCouponHeader }) => {
  const {
    type,
    queryText,
    stores,
    pickupDate,
    setPickupDate,
    selectedDate,
    setFavoriteStore,
    handleSelectShop,
    campaign,
  } = useShopSearch();

  return (
    <ShopSearchContainer $hasAppCoupon={showAppCouponHeader}>
      {type !== StoreSearchType.MyStore.valueOf() && (
        <TitleWrapper>
          <QueryText>{queryText}検索結果</QueryText>
          <ResultText>全{stores.length}件あります</ResultText>
        </TitleWrapper>
      )}

      <PickUpDateSelect
        onChange={setPickupDate}
        selectedDate={selectedDate}
        campaign={campaign}
      />

      <StoreListContainer>
        <StoreList
          stores={stores}
          pickupDate={pickupDate}
          selectedDate={selectedDate}
          hiddenShortestTime={!!campaign}
          campaign={campaign}
          onFavoriteStore={setFavoriteStore}
          onSelectStore={handleSelectShop}
        />
      </StoreListContainer>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </ShopSearchContainer>
  );
};

const ShopSearchContainer = styled.div<{ $hasAppCoupon: boolean }>`
  padding: 0;
  margin: ${({ $hasAppCoupon }) =>
    $hasAppCoupon ? "100px auto 80px" : "0 auto 80px"};
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const StoreListContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 10px;
  padding: 20px 0 75px;
`;

const TitleWrapper = styled.div`
  padding: 18px 0;
  color: ${BASIC_DARK_GRAY};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 80px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 500;
    line-height: 1em;
    height: auto;
  }
`;

const QueryText = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 1.2;
`;

const ResultText = styled.div`
  font-size: 16px;
  font-weight: 500;
`;
